import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// O <form> compartilhado desliga a validação nativa do browser (aquele balão
// "Preencha este campo", que não segue o visual do sistema e some ao rolar a
// página), então o atributo required do input não barra mais o envio sozinho:
// quem barra é o react-hook-form, mostrando o erro junto do campo como os
// demais. Forms com resolver ignoram estas regras — lá quem valida é o schema.
export default function useRequiredRule(required, rules) {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!required) return rules;

    // rules por último para que o form possa trocar a mensagem padrão.
    return { required: t("frontend.labels.validation.required"), ...rules };
  }, [required, rules, t]);
}
